export default __webpack_public_path__ + "static/32934-d50701cbb78678c97da6b3538130b04e.jpg";